import { toast } from "sonner";
import { OctagonXIcon } from "lucide-react";
import { useNavLoader } from "@/lib/nav-loader";

/** Unified «Недостаточно кредитов» toast.
 *
 * The action is rendered as a real `<a href="/account">` anchor so
 * tapping it is treated by the browser as a native user-initiated
 * navigation — nothing the surrounding overlays (Radix focus scope,
 * vaul drawer body lock, iOS popup blocker) can intercept.
 *
 * Two important quirks worked around here:
 *
 * 1. We deliberately do NOT call `toast.dismiss(id)` from the click
 *    handler. Sonner unmounts the toast root synchronously on
 *    dismiss, which on iOS Safari rips the anchor out of the DOM
 *    before the browser commits the navigation — clicking the
 *    button felt like a no-op. The toast just auto-closes after
 *    its duration, or via the in-built dismiss button.
 *
 * 2. On desktop we still want the centered AccountModal experience,
 *    so onClick preventsDefault and dispatches `open-pricing`. */
export function showInsufficientCreditsToast() {
    toast.custom(
        (_id) => (
            <div className="group toast bg-popover/95 backdrop-blur-md text-popover-foreground border border-destructive/40 shadow-2xl shadow-black/20 rounded-xl px-3.5 py-3 text-sm font-medium tracking-tight w-full max-w-[420px] flex items-center gap-3">
                <OctagonXIcon className="size-4 shrink-0 text-destructive" />
                <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold tracking-tight">Недостаточно кредитов</div>
                    <div className="text-[12.5px] text-muted-foreground leading-snug mt-0.5">
                        Пополните баланс
                    </div>
                </div>
                <a
                    href="/account"
                    onClick={(e) => {
                        if (typeof window === "undefined") return;
                        const isDesktop = window.matchMedia("(min-width: 768px)").matches;
                        if (isDesktop) {
                            e.preventDefault();
                            window.dispatchEvent(new CustomEvent("open-pricing"));
                            return;
                        }
                        // Mobile: let the anchor href do the actual nav, but
                        // surface the global NavLoader so the user doesn't
                        // see the previous screen flash through while the
                        // browser loads /account. Don't preventDefault and
                        // don't dismiss the toast synchronously — sonner's
                        // unmount cancels the in-flight nav on iOS.
                        useNavLoader.getState().show();
                    }}
                    className="bg-primary text-primary-foreground rounded-md px-2.5 py-1 text-xs font-semibold shrink-0 active:scale-95 transition-transform no-underline"
                >
                    Пополнить
                </a>
            </div>
        ),
        { duration: 6000 },
    );
}
